const topbar = {
    docs: 'Belgeler',
    help: 'Yardım',
};
export default Object.freeze(topbar);
